module.exports = __webpack_public_path__ + "img/1.e285cf04.svg";